import React from 'react';

import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import Lista from 'components/Windx/ControlPanel/SavedPreferences/Lista';
import FormSalvar from 'components/Windx/ControlPanel/SavedPreferences/FormSalvar';
import useSavedPreferences, {
  SavedPreferencesSnapshot,
} from 'components/Windx/ControlPanel/SavedPreferences/useSavedPreferences';
import { WindxTela } from 'helper/windx';

interface PreferenciasProps {
  tela: Extract<WindxTela, 'sh' | 'sm' | 'comparativo'>;
  snapshot: SavedPreferencesSnapshot;
  open: boolean;
  onToggle: () => void;
  showSaveForm: boolean;
  onCloseSaveForm: () => void;
}

/**
 * Secao "Preferências salvas" do painel mobile (Task 8 do spec Windx mobile).
 *
 * REUSA do desktop o estado (`useSavedPreferences`), a lista (`Lista`) e o
 * formulario (`FormSalvar`) — aqui so muda a casca: `Section` do BottomSheet no
 * lugar do `Accordion.Item`. Reescrever a lista duplicaria as regras de
 * restauracao (WINDX-030/046/056 e FE-WINDX-045).
 *
 * O `FormSalvar` fica FORA do `Section` de proposito: quem o abre e o botao
 * "Salvar preferência" do rodape do sheet, que segue visivel com a secao
 * fechada. Dentro do `Section` ele so existiria com a secao aberta.
 */
export default function Preferencias({
  tela, snapshot, open, onToggle, showSaveForm, onCloseSaveForm,
}: PreferenciasProps) {
  const {
    prefs, isLoadingList, isDeleting, isSaving,
    nome, setNome, handleRestore, handleDelete, handleDismiss, handleSave,
  } = useSavedPreferences({ tela, snapshot, onCloseSaveForm });

  return (
    <>
      <Section label="Preferências salvas" open={open} onToggle={onToggle}>
        <Lista
          prefs={prefs}
          isLoadingList={isLoadingList}
          isDeleting={isDeleting}
          onRestore={handleRestore}
          onDelete={handleDelete}
        />
      </Section>

      <FormSalvar
        open={showSaveForm}
        isSaving={isSaving}
        nome={nome}
        onNomeChange={setNome}
        onDismiss={handleDismiss}
        onSubmit={handleSave}
      />
    </>
  );
}
